import Layout from "./Shared/Layout";
import { useNavigate } from 'react-router-dom';
import { FaArrowLeft } from 'react-icons/fa';
import { Helmet } from "react-helmet";

const SizeChart = () => {
    const navigate = useNavigate();

    const handleBackClick = () => {
        navigate(-1);
    };

    return (
        <Layout>
            <Helmet>
                {/* Title Tag */}
                <title>Gailee Size Guide-Find Your Perfect Fit in Kurtas, Bottoms & Sets</title>
                {/* Meta Description */}
                <meta
                    name="description"
                    content="Use our detailed size chart to pick the right fit for your kurtas, bottoms, and ethnic sets. Designed to flatter all body types with elegant silhouettes."
                />
                {/* Meta Robots Tag */}
                <meta name="robots" content="index, follow" />
                {/* Open Graph Tags */}
                <meta property="og:title" content="Gailee Size Guide – Find Your Perfect Fit in Kurtas, Bottoms & Sets" />
                <meta property="og:description" content="Use our detailed size chart to pick the right fit for your kurtas, bottoms, and ethnic sets. Designed to flatter all body types with elegant silhouettes." />
                {/* Structured Data (Schema.org) */}
                <script type="application/ld+json">{`
            {
              "@context": "https://schema.org",
              "@type": "WebPage",
              "name": "Gailee Size Guide",
              "description": "Use our detailed size chart to pick the right fit for your kurtas, bottoms, and ethnic sets. Designed to flatter all body types with elegant silhouettes."
            }
            `}</script>
            </Helmet>
            <div className="layout_main">
                <div className="container">
                    <div className="page-header mb-3 d-flex align-items-center">
                        <button
                            className="back-button d-flex align-items-center"
                            onClick={handleBackClick}
                            style={{
                                backgroundColor: 'transparent',
                                border: 'none',
                                fontSize: '24px',
                                cursor: 'pointer',
                                marginRight: '10px'
                            }}
                        >
                            <FaArrowLeft />
                        </button>
                        {/* H1 tag for SEO only, not visible on page */}
                        <h1 style={{ display: "none" }}>
                            Gailee Size Guide – Fit That Feels Right
                        </h1>
                        <h1>Size Chart</h1>
                    </div>
                    <section className="sizechart_wrapper">
                        <p>Refer to the size chart below to get the correct fit for yourself</p>

                        <div>
                            {/* <img className="sizechart_image" src="./images/sizechart.JPG" alt="Hand-stitched chikankari kurta – Gailee" /> */}
                            <img className="sizechart_image" src="./images/sizechart1.png" alt="Hand-stitched chikankari kurta – Gailee" />
                            <ul className="sizechart_content mt-3">
                                <li>All garments have little to no margin.</li>
                                <li>If you’re on the borderline between two sizes, order the smaller size for a tighter fit or a larger size for a relaxed fit. However, please remember the larger size can always be altered if need be.</li>
                                <li>Garment measurements refer to the outfit's measurements when laid flat.</li>
                            </ul>
                        </div>

                        <h3 className="mb-3 mt-5">Sizing & Fit Guide</h3>
                        <div>
                            <ul className="sizechart_content">
                                <li><strong>Bust:</strong>Wrap the measuring tape loosely around the fullest part of your bust to ensure a comfortable fit.</li>
                                <li><strong>Waist:</strong>Measure the narrowest part of your natural waist, holding the measuring tape loose enough to fit comfortably.</li>
                                <li><strong>Hips:</strong>Drape the measuring tape around the widest part of your hips, resting the tape comfortably against your body.</li>
                            </ul>
                        </div>
                        <p>Please be aware that all of our products are hand stitched, hence there can be some minor adjustments issues to some of them. However, our team does its best to make sure that correct size is delivered to you. </p>
                        <p>
                            If you have questions regarding sizing or any other information on a specific item,
                            please email us at
                            <a href="mailto:support@gailee.in" className="email" title="About Gailee - Learn about our brand"> support@gailee.in</a>
                            or WhatsApp on
                            <a href="tel:8756562626" className="mobile" title="About Gailee - Learn about our brand"> 8756562626</a>
                            for specific details.
                        </p>
                    </section>
                </div>
            </div>
        </Layout>
    );
}

export default SizeChart;